import cn from "classnames";
import styles from "./Loader.module.scss";

type PreloaderProps = {
  className?: string;
};

export const Loader = ({ className }: PreloaderProps) => {
  return (
    <div className={cn(styles.loaderWrap, className)}>
      <div className={cn(styles.loader)} />
    </div>
  );
};
